import { START_LOADING, END_LOADING, UPDATE_LOADING_MESSAGE } from '@app/actions/_types';

export const startLoading = loadingMessage => ({
  type: START_LOADING,
  payload: loadingMessage,
});

export const updateLoadingMessage = loadingMessage => ({
  type: UPDATE_LOADING_MESSAGE,
  payload: loadingMessage,
});

export const endLoading = () => ({
  type: END_LOADING,
});
